var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShChannelOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    transform: "translate(-559 -774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    transform: "translate(559 774)",
    fill: "#fefe89",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SH",
    transform: "translate(571 792)",
    fill: "#595959",
    fontSize: 15,
    fontFamily: "Quicksand-Bold, Quicksand",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.87,
    y: 0
  }, "SH")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShChannelOn);
export default __webpack_public_path__ + "static/media/SHChannel-on.343dccc21ecb0cbb6989e89994e9a026.svg";
export { ForwardRef as ReactComponent };